import { Injectable } from '@angular/core';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
@Injectable({
  providedIn: 'root',
})
export class ChecklistService {
  title: BehaviorSubject<string> = new BehaviorSubject(localStorage.getItem('checklist-title') ?? 'Checklist');

  constructor(private readonly httpService: AmplifyHttpClient) {}

  getCheckLists(id) {
    const url = `api/checklist/checklist/${id}`;
    return this.httpService.get(url, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  getCheckList(userId, type, typeId, params) {
    const url = `api/checklist/item/${userId}/${type}/${typeId}/${params}`;
    return this.httpService.get(url, null, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }
  // Professional Workspace
  createChecklistTemplate(request) {
    const url = `api/checklist/template`;
    return this.httpService.post(url, request, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }
  deleteChecklistItems(request: {
    userId: string | number | null;
    reminders: Array<string | number | null | any>;
    tasks: Array<string | number | null | any>;
  }) {
    const url = `api/checklist/checklist-delete`;
    return this.httpService.post(url, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) return response;
        if (response.status !== 200) return response;
      })
    );
  }
  updateChecklistStatus(request: {
    userId: string | number | null;
    reminders: Array<string | number | null | any>;
    tasks: Array<string | number | null | any>;
    status: 'inprogress' | 'complete' | 'notstarted';
  }) {
    const url = `api/checklist/checklist-status`;
    return this.httpService.patch(url, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) return response;
        if (response.status !== 200) return response;
      })
    );
  }
  getMySetupChecklists() {
    const url = `api/checklist/checklist-master-setup`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
  getMySetupChecklistsData() {
    const url = `api/checklist/checklist-setup`;
    return this.httpService.get(url, null, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
  setTitle(title) {
    localStorage.setItem('checklist-title', title);
    this.title.next(title);
  }
  getMyMaintenanceChecklists() {
    const url = `api/checklist/checklist-master`;
    return this.httpService.get(url, null, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
}
